// @flow
import {
  LOAD_SHARED_LINKS,
  ADD_SHARED_LINK,
  DELETE_SHARED_LINK,
  LOAD_LINK_DATA,
  SET_UPLOAD_SETTINGS,
  SET_DOWNLOAD_SETTING,
  SET_HAS_PASSWORD,
  SET_EXPIRES,
  SET_EMAILS_WITH_UPLOAD_ACCESS,
  SET_SHORT_LINK_URL
} from "../constants/sharedLinks";
import type { Action } from "../actions/types";

export type UploadSettings = {
  isUploadDisabled: boolean,
  canEveryoneUpload: boolean,
  isRestrictedUpload: boolean
};

export type LinkData = {
  code: string,
  linId: string,
  linkUrl: string,
  shortLinkUrl: string,
  type: number,
  linkName: string,
  hasPassword: boolean,
  expirationDate: boolean | Date,
  created: string,
  downloads: number,
  traffic: number,
  uploadSettings: UploadSettings,
  emailsWithUploadAccess: Array<string>,
  canDownload: boolean
};

export type SharedLinkState = {
  loadedLinkData: boolean,
  loadedSharedLinks: boolean,
  sharedLinks: Array<any>,
  linkData: LinkData,
  isUploadSerringsDropdownOpen: boolean
};

const initialState: SharedLinkState = {
  loadedLinkData: false,
  loadedSharedLinks: false,
  sharedLinks: [],
  linkData: {
    code: "",
    linId: "",
    linkUrl: "",
    shortLinkUrl: "",
    linkName: "",
    hasPassword: false,
    expirationDate: false,
    created: "",
    downloads: 0,
    traffic: 0,
    uploadSettings: {
      isUploadDisabled: true,
      canEveryoneUpload: false,
      isRestrictedUpload: false
    },
    canDownload: false,
    emailsWithUploadAccess: []
  },
  isUploadSerringsDropdownOpen: false
};

const addLink = (state, data) => {
  const { sharedLinks } = state;
  sharedLinks.push(data);
  return { ...sharedLinks };
};

const deleteLink = (state, data) => {
  const { sharedLinks } = state;
  const filtredSharedLinks = sharedLinks.filter(item => item.id !== data.id);
  return { ...filtredSharedLinks };
};

export function sharedLinksReducer(
  state: SharedLinkState = initialState,
  action: Action
): SharedLinkState {
  const { type, payload } = action;

  switch (type) {
    case LOAD_SHARED_LINKS:
      return { ...state, loadedSharedLinks: true, sharedLinks: payload };
    case ADD_SHARED_LINK:
      return { ...state, sharedLinks: addLink(state, payload) };
    case DELETE_SHARED_LINK:
      return { ...state, sharedLinks: deleteLink(state, payload) };
    case LOAD_LINK_DATA:
      return { ...state, loadedLinkData: true, linkData: action.linkData };
    case SET_UPLOAD_SETTINGS:
      return { ...state, linkData: { ...state.linkData, uploadSettings: action.settings } };
    case SET_DOWNLOAD_SETTING:
      return { ...state, linkData: { ...state.linkData, canDownload: action.canDownload } };
    case SET_HAS_PASSWORD:
      return { ...state, linkData: { ...state.linkData, hasPassword: payload } };
    case SET_EXPIRES:
      return { ...state, linkData: { ...state.linkData, expirationDate: payload } };
    case SET_EMAILS_WITH_UPLOAD_ACCESS:
      return { ...state, linkData: { ...state.linkData, emailsWithUploadAccess: action.emails } };
    case SET_SHORT_LINK_URL:
      return { ...state, linkData: { ...state.linkData, shortLinkUrl: payload } };
    default:
      return state;
  }
}
